
import { ClinicalRecordType } from '../clinical-record-type.model';
import {
    ClinicalRecordTypeActions, ClinicalRecordTypeActionTypes
} from './clinical-record-type.actions';

export interface ClinicalRecordTypeState {
  items: ClinicalRecordType[];
  loaded: boolean;
}

export const initialState: ClinicalRecordTypeState = {
  items: [],
  loaded: false,
};

export function clinicalRecordTypeReducer(state = initialState, action: ClinicalRecordTypeActions): ClinicalRecordTypeState {
  switch (action.type) {

    case ClinicalRecordTypeActionTypes.LoadClinicalRecordTypesSuccess:
      return {
        ...state,
        items: action.payload,
        loaded: true
      };

    case ClinicalRecordTypeActionTypes.LoadClinicalRecordTypesFail:
      return {
        ...state,
        loaded: false
      };

    default:
      return state;
  }
}
